import {call, put,takeLatest,select,} from 'redux-saga/effects';
import {
    LOGIN_FAIL,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    MANAGER_PROFILE_FAIL,
    MANAGER_PROFILE_SUCCESS,
    MANAGER_PROFILE_REQUEST,
    MANAGER_UPDATE_REQUEST,
    MANAGER_UPDATE_SUCCESS,
    MANAGER_UPDATE_FAIL,
    MANAGER_NOTIFICATION_SUCCESS,
    MANAGER_NOTIFICATION_FAIL,
    MANAGER_NOTIFICATION_REQUEST,
    MANAGER_NOTIFY_SUCCESS,
    MANAGER_NOTIFY_FAIL, MANAGER_NOTIFY_REQUEST

} from '../actions/manager.js';
import Api from '../../Api.js';
import _ from 'lodash';
import {toast} from "react-toastify";
import {navigateTo} from '../actions/navigateTo.js';
import {word} from "../../word.js";
import Account from "../../helpers/Account.js";
const successNotify = () => toast.success(word.success_process,  { position: "top-center",theme: "colored", });
const errorNotify = () => toast.error(word.error_process,  { position: "top-center",theme: "colored", });
function* handleLoginRequest(action) {

    try {
        const {form,pref} = action.payload;
        const {data} = yield call(Api.login, form, pref);
        successNotify()
        localStorage.setItem('token',data.token)
        yield put({
            type: LOGIN_SUCCESS,
            payload: {data},
        });
        yield put(navigateTo('/'));
    } catch (e) {
        errorNotify()
        yield put({
            type: LOGIN_FAIL,
            payload: {error: e.response},
        });
    }
}

function* handleProfileRequest(action) {
    try {
        const {prof,id} = action.payload;
        const alreadyFetched = yield select((state) => state.manager.employee);
        if (!_.isEmpty(alreadyFetched)) return;
        const {data} = yield call(Api.profileManager, prof,id);
        yield put({
            type: MANAGER_PROFILE_SUCCESS,
            payload: {data},
        });
        Account.setData(data.manager?data.manager:data)

        yield put(navigateTo('/'))
    } catch (e) {
        console.log(e)
        toast.error(word.error_process,  { position: "top-center",theme: "colored", });
        yield put({
            type: MANAGER_PROFILE_FAIL,
            payload: {error: e.response},
        });
    }
}


function* handleManagerUpdateRequest(action) {
    try {
        const {form,id} = action.payload;
        yield call(Api.managerUpdate, form,'',id);
        const {data} = yield call(Api.managerUpdateGet);
        yield put({
            type: MANAGER_UPDATE_SUCCESS,
            payload: {data},
        });
        successNotify()

    } catch (e) {
        errorNotify()
        yield put({
            type: MANAGER_UPDATE_FAIL,
            payload: {error: e.response},
        });
    }
}

function* handleNotificationRequest(action) {
    try {
        const alreadyFetched = yield select((state) => state.manager.notification);
        if (!_.isEmpty(alreadyFetched) && !action.payload.fetch) return;
        const {data} = yield call(Api.notification);
        yield put({
            type: MANAGER_NOTIFICATION_SUCCESS,
            payload: {data},
        });

    } catch (e) {

        yield put({
            type: MANAGER_NOTIFICATION_FAIL,
            payload: {error: e.response},
        });
    }
}
function* handleNotifyRequest(action) {
    try {
        const alreadyFetched = yield select((state) => state.manager.notify);
        if (alreadyFetched && !action.payload.fetch) return;
        let newFilter = {}
        if (localStorage.getItem("profession") === "accountant") {
            newFilter = {
                accountants_client_eq: localStorage.getItem("id"),
                accountant_neq: localStorage.getItem("id"),
                accountant_eq: "",
            };
        } else {
            newFilter = {
                manager_eq: "",
                manager_neq: localStorage.getItem("id"),
                managers_client_eq: localStorage.getItem("id"),
            };
        }
        let s = new URLSearchParams(newFilter).toString();
        const {data} = yield call(Api.getNotificationCount,s);
        yield put({
            type: MANAGER_NOTIFY_SUCCESS,
            payload: {data},
        });

    } catch (e) {

        yield put({
            type: MANAGER_NOTIFY_FAIL,
            payload: {error: e.response},
        });
    }
}

export default function* watcher() {
    yield takeLatest(LOGIN_REQUEST, handleLoginRequest);
    yield takeLatest(MANAGER_NOTIFICATION_REQUEST, handleNotificationRequest);
    yield takeLatest(MANAGER_NOTIFY_REQUEST, handleNotifyRequest);
    yield takeLatest(MANAGER_PROFILE_REQUEST, handleProfileRequest);
    yield takeLatest(MANAGER_UPDATE_REQUEST, handleManagerUpdateRequest);
}
